import { createBrowserHistory } from 'history'
import pathToRegexp from 'path-to-regexp'

export const history = createBrowserHistory()

export const getQueryStringParams = (query) => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
      .split('&')
      .reduce((params, param) => {
        const [key, value] = param.split('=')
        return {
          ...params,
          [key]: value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
        }
      }, {})
    : {}
}

export const isCurrentURL = (exp, url) => {
  const res = pathToRegexp(exp)
  return url.match(res) ? url : false
}

export const getCurrentPath = () => {
  return history.location.pathname
}



// WEBPACK FOOTER //
// ./src/utils/routes.js